<template>
	<div>
		<span class="ml-3 mr-7" v-if="show_label">{{$t('_periodes_') }}</span>
		<v-menu
			:value="menu"
      :close-on-click="false"
			:close-on-content-click="false"      
      content-class="custom-datepicker-menu"			
      persistence
			transition="scale-transition"
			offset-y
		>
    <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col cols="12" sm="6" md="4"> <!-- Adjust the md/cols value to fit your layout needs -->
            <v-text-field
              dense
              v-model="dateRangeText"
              prepend-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"                      
              @click="openCalendar"
              @click:prepend="resetCalendar"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </template>

      <v-date-picker
      v-if="menu"
      v-model="dates"
      :min="min_date"
      :max="max_date"
      :locale="currentLocale"
     
      range
      scrollable
      elevation="10"
    >
        <v-spacer></v-spacer>
        <v-btn text color="black" @click="cancelDate"> {{ $t('_annuler_') }}</v-btn>
        <v-btn text color="primary" @click="saveDate">{{ $t('_rafraichir_') }}</v-btn>
      </v-date-picker>
		</v-menu>
	</div>
</template>

<script>

import dt_form from "../../utils/date_tools";

export default {
	props: {
    min_date: {
      type: String,
      default: "",
    },
    max_date: {
      type: String,
      default: "",
    },
		show_label: {
			type: Boolean,
			default: true,
		},
    store_cal_event: {
      type: String,
    },
    store_date: {
      type: Object,
    },
    store_date_commit: {
      type: String
    },
    default_last_month: {
      type: Boolean,
      default: false
    }
	},
  computed: {
  currentLocale() {
    return this.$i18n.locale;
    }
  },
  watch: {
  '$i18n.locale': {
    handler(newLocale) {
      this.$vuetify.lang.current = newLocale;     
    },
    immediate: true
  }
},


  data() {
		return {
      dates: [this.store_date.start, this.store_date.end],
      dateRangeText: `${this.store_date.start} -> ${this.store_date.end}`,
      menu: false,
      items: ['< 1 mois', '< 6 mois', '< 1 an', 'Toute la période'],
		};
	},

	methods: {
    setDateRange(startDate, endDate) {
      if (startDate !== undefined && endDate !== undefined) {
        const checkedDates = this.checkSortDate(startDate, endDate)
        this.dateRangeText = `${checkedDates['start']} -> ${checkedDates['end']}`
      } else {
        this.dateRangeText = `${this.store_date.start} -> ${this.store_date.end}`
      }
    },

    checkSortDate(startDate, endDate) {
      if (startDate !== undefined && endDate !== undefined) {
        return {
          "start": (startDate < endDate) ? startDate : endDate,
          "end": (startDate < endDate) ? endDate : startDate
        }
      } else {
        return {"start": null, "end": null}
      }
    },

    resetCalendar() {
      let checkedDates
      if (this.default_last_month) {
        const end_dt = dt_form.dateFormat(this.max_date, "endMonth", "sys")
        const start_dt = dt_form.dateFormat(this.max_date, "startMonth", "sys")
        checkedDates = this.checkSortDate(start_dt, end_dt)
      } else {
        checkedDates = this.checkSortDate(this.min_date, this.max_date)
      }
      this.updateDates('START', checkedDates['start'])
      this.updateDates('END', checkedDates['end'])
      this.setDateRange(checkedDates['start'], checkedDates['end'])
      this.$store.commit(this.store_cal_event, true)
    },

    openCalendar() {
      this.dates[0] = this.store_date.start
      this.dates[1] = this.store_date.end
      this.menu = true
    },

    cancelDate() {
      this.menu = false
      const checkedDates = this.checkSortDate(this.store_date.start, this.store_date.end)
      this.dates[0] = checkedDates['start']
      this.dates[1] = checkedDates['end']
    },

    saveDate() {
      this.menu = false
      const checkedDates = this.checkSortDate(this.dates[0], this.dates[1])
      this.updateDates('START', checkedDates['start'])
      this.updateDates('END', checkedDates['end'])
      this.setDateRange(checkedDates['start'], checkedDates['end'])

      this.$store.commit(this.store_cal_event, true)
    },

		updateDates(key, value = null) {
      if (value) {
        this.$store.commit(`${this.store_date_commit}_${key.toUpperCase()}`, value);
      }
		},
	},
};

</script>
<style scoped>
.v-menu__content {
  min-width: 290px!important;
}


.text-field-row {
  display: flex;
  justify-content: flex-start; /* Align text field to the left initially */
  transition: all 0.3s ease-in-out; /* Smooth transition for resizing */
}

.v-text-field {
  width: 100%; /* Make it responsive to available width */
  max-width: 100%; /* Ensure it doesn't exceed the screen width */
  min-width: 230px; /* Set a minimum width */
}

.v-text-field input {
  white-space: normal;  /* Allow text to wrap */
  overflow: hidden;    /* Allow overflow */
  text-overflow:unset; /* Remove ellipsis */
}

@media screen and (max-width: 600px) {
  .v-text-field {
    font-size: 12px; /* Smaller text size for mobile */
  }

  .text-field-row {
    justify-content: center; /* Center the text field on smaller screens */
  }
}

@media screen and (max-width: 400px) {
  .v-text-field {
    font-size: 10px; /* Further reduce text size on very small screens */
    text-overflow: ellipsis; /* Allow ellipsis on very small screens */
  }
}

</style>